module.exports = __webpack_public_path__ + "static/img/guide-bg2.4b048d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide-bg2.png
// module id = +nKr
// module chunks = 2